import { render } from "./CreateWork.vue?vue&type=template&id=29b5f87f&scoped=true"
import script from "./CreateWork.vue?vue&type=script&lang=js"
export * from "./CreateWork.vue?vue&type=script&lang=js"

import "./CreateWork.vue?vue&type=style&index=0&id=29b5f87f&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b5f87f"]])

export default __exports__